import { create } from "zustand";

/**
 * Which mounted phone/SMS fields currently hold an invalid entry (ENG-2302).
 *
 * Edit-mode tabs are rendered as elements stashed in parent state, so the
 * Save button can't read a field's validity through props. A field reports
 * here while mounted (and clears itself on unmount); Save buttons disable
 * while any field is invalid.
 */
interface PhoneValidationState {
  invalidFields: Record<string, boolean>;
  setFieldInvalid: (key: string, invalid: boolean) => void;
}

export const usePhoneValidationStore = create<PhoneValidationState>((set) => ({
  invalidFields: {},
  setFieldInvalid: (key, invalid) =>
    set((state) => {
      if (Boolean(state.invalidFields[key]) === invalid) return state;
      const invalidFields = { ...state.invalidFields };
      if (invalid) invalidFields[key] = true;
      else delete invalidFields[key];
      return { invalidFields };
    }),
}));

export const selectAnyPhoneFieldInvalid = (state: PhoneValidationState) =>
  Object.keys(state.invalidFields).length > 0;
